import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import type { DescriptionDto } from '@/api';
import { getProviderIconSrc } from '@/utils/provider-icons';
import SIcon from '@/components/SIcon.vue';
import ExternalDescription from './External-Description.vue';

interface ExternalDescriptionsProps {
  descriptions: DescriptionDto[];
  textSearch?: string;
  asCard?: boolean;
  shouldShowRichtext?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'External-Descriptions',
  props: {
  descriptions: null,
  textSearch: { default: '' },
  asCard: { type: Boolean, default: false },
  shouldShowRichtext: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;


const outlined = _computed(() => props.asCard);
const backgroundColor = _computed(() => (props.asCard ? 'var(--v-bgPageSecondary-base)' : 'transparent'));

const groupedDescriptionsByText = _computed(() => {
  const textToSourceTypes = new Map<string, DescriptionDto.sourceType[]>();

  props.descriptions.forEach((desc) => {
    if (desc.sourceType) {
      const text = desc.description || '';

      if (!textToSourceTypes.has(text)) {
        textToSourceTypes.set(text, []);
      }

      const sourceTypes = textToSourceTypes.get(text)!;
      if (!sourceTypes.includes(desc.sourceType)) {
        sourceTypes.push(desc.sourceType);
      }
    }
  });

  return Array.from(textToSourceTypes.entries()).map(([text, sourceTypes]) => ({
    text,
    sourceTypes,
  }));
});

return { __sfc: true,props, outlined, backgroundColor, groupedDescriptionsByText, _computed, getProviderIconSrc, SIcon, ExternalDescription }
}

})